/**
 * 45 -> "45 min", 60 -> "1 hr", 90 -> "1 hr 30 min". What the customer spends in the chair.
 * `short` drops the trailing "min" after hours, for the action bar ("1 hr 30").
 */
export function formatDuration(
  minutes: number,
  { short = false }: { short?: boolean } = {},
): string {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} min`;
  if (rest === 0) return `${hours} hr`;
  return short ? `${hours} hr ${rest}` : `${hours} hr ${rest} min`;
}
